import {Button, Container, Paper, Stack, Typography} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {getAuthManager} from "../utils/auth";

export default function Login() {
    const navigate = useNavigate();

    const navigateToLogin = async () => {
        const authManager = getAuthManager();
        await authManager.initialize();
        navigate("/");
    };

    return (
        <Container maxWidth="xs">
            <Stack alignItems="center">
                <Paper sx={{mt: 8, maxWidth: 300}}>
                    <Stack spacing={2} sx={{p: 2}} alignItems="center">
                        <img
                            width={100}
                            height={100}
                            src="/images/logo_default.svg"
                        />

                        <Typography color="primary">
                            پنل کاربری پرشین سازه
                        </Typography>

                        <Typography color="text.secondary">
                            برای استفاده از پنل لطفا فرایند ورود را طی کنید
                        </Typography>

                        <Button
                            fullWidth
                            variant="contained"
                            onClick={navigateToLogin}
                        >
                            ورود به پنل
                        </Button>
                    </Stack>
                </Paper>
            </Stack>
        </Container>
    );
}
